import { ofType } from 'redux-observable';
import { map } from 'rxjs/operators/map';
import { switchMap } from 'rxjs/operators/switchMap';
import { catchError } from 'rxjs/operators/catchError';
import { types as actions, addedCategoryAction } from '../../reducers/actions';
import { CategoryService } from '../../services';
import { retryAuthentication } from '../../utils/epics/retryAuthentication';

export default function(action$, store) {
  return action$.pipe(
    ofType(actions.ADD_CATEGORY),
    switchMap(action =>
      CategoryService.create(action.category, store).pipe(
        map(data => addedCategoryAction(data)),
        catchError(retryAuthentication(action$, 'epics/categories/addCategory'))
      )
    )
  );
}



// WEBPACK FOOTER //
// ./src/epics/categories/addCategory.js